import { flushSync } from "react-dom";
import { createRoot } from "react-dom/client";

import { formatSalesUnits, standardFormateWithDecoration } from "../NumberConversations";
import { RelianceChartToolTip } from "./RelianceChartToolTip";
import { SalesByCompositionToolTip } from "./SalesByCompositionTooltip";

const Basic = (params = [], data) => {
  let tooltip;
  try {
    const signAfter = data?.signAfter || "";
    const signBefore = data?.signBefore || "";

    const xAxisName = params[0].name;

    // stack name
    tooltip = `
        <div class="echarts-custom-tooltip">
          <p><span class="echarts-custom-tooltip__bold">${xAxisName}</span></p>
    `;

    // loop all stack item
    params.forEach((item) => {
      const seriesName = item.seriesName;
      const value = standardFormateWithDecoration({
        value: item.data.value,
        endSign: signAfter,
        frontSign: signBefore,
      });
      const { color, borderColor } = item.data.itemStyle;

      //   circle + item name + value (% || $)
      tooltip += `
        <div style="display: flex; justifyContent: center;margin-top: 10px; margin-bottom: 10px">
            <span style="display:inline-block;margin-right:5px;border-radius:50%;width:13px;height:13px;background-color:${color};border: 1px solid ${borderColor}"></span>
            <span class="echarts-custom-tooltip__bold">${seriesName}: ${value}</span>
        </div>
      `;
    });

    tooltip += "</div>";
    return tooltip;
  } catch (error) {
    // pass
  }
  return tooltip;
};

const SalesByComposition = (item, meta, formatCurrency) => {
  const { seriesTotals } = meta;

  try {
    const { color, borderColor } = item;

    const isDollarViewSelected = meta?.isDollarViewSelected;
    const salesUnitLabel = meta?.salesUnitsLabel;

    const title = item.name;
    const seriesName = item.seriesName;

    const value = isDollarViewSelected ? formatCurrency(item.value) : formatSalesUnits(item.value);

    const total = isDollarViewSelected
      ? formatCurrency(seriesTotals?.[item.dataIndex])
      : formatSalesUnits(seriesTotals?.[item.dataIndex]);

    const tooltipRoot = document.createElement("div");
    const root = createRoot(tooltipRoot);
    flushSync(() => {
      root.render(
        <SalesByCompositionToolTip
          title={title}
          seriesName={seriesName}
          value={value}
          total={total}
          color={color}
          borderColor={borderColor}
          isDollarViewSelected={isDollarViewSelected}
          salesUnitsLabel={salesUnitLabel}
        />
      );
    });

    return tooltipRoot.innerHTML;
  } catch (error) {
    console.error(error);
  }
};

const RelianceRanking = (item, meta) => {
  try {
    if (!item.length) return;
    const dataIndex = item[0].dataIndex;
    const totalSales = meta.seriesTotals[dataIndex];
    const formatCurrency = meta.config.currency.formatCurrency;
    const NO_DATA = "NA";

    const totalSalesDisplayName = totalSales ? formatCurrency(totalSales) : NO_DATA;

    const seriesData = item.map((data) => {
      const percentage = 100 * (data.value / totalSales);
      return {
        name: data.name,
        color: data.color,
        borderColor: data.borderColor,
        seriesName: data.seriesName,
        value: data.value ? formatCurrency(data.value) : NO_DATA,
        percentage: `${parseFloat(percentage).toFixed(2)}%`,
      };
    });

    const tooltipRoot = document.createElement("div");
    const root = createRoot(tooltipRoot);
    flushSync(() => {
      root.render(
        <RelianceChartToolTip seriesData={seriesData} totalSales={totalSalesDisplayName} />
      );
    });

    return tooltipRoot.innerHTML;
  } catch (error) {
    console.error(error);
  }
};

/**
 * EchartsUtils will be migrated to here after five layer go online
 * @param {*} param as tooltip trigger is axis, so it's array
 * @returns
 */
export const getHoverTooltip = ({ params, data, componentName, formatCurrency }) => {
  try {
    if (componentName === "Basic") {
      return Basic(params, data);
    } else if (componentName === "RelianceRanking") {
      return RelianceRanking(params, data);
    } else if (componentName === "SalesByComposition") {
      return SalesByComposition(params, data, formatCurrency);
    }
  } catch (error) {
    console.log(error);
  }
  return <></>;
};
